<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
  >
    <el-form ref="envform" :rules="rules" :model="env">
      <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
        <el-input v-model="env.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="envType" label="环境类别" :label-width="formLabelWidth">
        <el-select style="width: 100%" v-model="env.envType" placeholder="选择环境类别">
          <el-option
            key="rainbond"
            label="Rainbond"
            value="rainbond"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="url" label="API域名" :label-width="formLabelWidth">
        <el-input @change="setPlatformURL" v-model="env.url" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="platformURL" label="控制台域名" :label-width="formLabelWidth">
        <el-input v-model="env.platformURL" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item prop="token" label="请求Token" :label-width="formLabelWidth">
        <el-input v-model="env.token" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { createDeliveryEnv, updateDeliveryEnv } from '@/api/delivery';
import { errorHandle } from '@/utils/error';
export default {
  name: 'EditDeliverEnv',
  props: {
    envEdit: {
      type: Object
    },
    appID: String,
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    const validateURL = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      // 支持域名和IP地址(含端口)的URL格式
      const urlPattern = /^(https?:\/\/)([\da-z\.-]+|[\d\.]+)(:\d+)?(\/.*)?$/i;
      if (!urlPattern.test(value)) {
        callback(new Error('请输入正确的URL地址(如: http://domain.com 或 http://1.1.1.1:8080)'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        name: [
          { required: true, message: '请提供环境名称', trigger: 'blur' },
          { max: 255, message: '分类名称必须小于255个字符', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请提供环境API域名', trigger: 'blur' },
          { max: 2047, message: '通信地址必须小于2047个字符', trigger: 'blur' },
          { validator: validateURL, trigger: 'blur' }
        ],
        platformURL: [
          { required: true, message: '请提供平台访问域名', trigger: 'blur' },
          { max: 2047, message: '通信地址必须小于2047个字符', trigger: 'blur' },
          { validator: validateURL, trigger: 'blur' }
        ],
        token: [
          { required: true, message: '请提供环境通信密钥', trigger: 'blur' },
          { max: 128, message: 'token最大128个字符', trigger: 'blur' }
        ],
        envType: [
          { required: true, message: '请选择环境类型', trigger: 'blur' }
        ]
      },
      env: {
        name: '',
        url: '',
        platformURL: '',
        token: '',
        envType: 'rainbond'
      },
      app: {},
      title: '添加交付环境',
      formLabelWidth: '100px',
      Loading: false
    };
  },
  created() {
    if (this.envEdit.envID) {
      this.title = '更新环境信息'
      this.env = Object.assign({}, this.envEdit)
    }
  },
  methods: {
    setPlatformURL(url) {
      if (!this.envEdit.envID) {
        this.env.platformURL = url
      }
    },
    submit() {
      this.Loading = true;
      this.$refs.envform.validate(valid => {
        if (valid) {
          this.env.marketID = this.marketID
          if (this.env.envID) {
            updateDeliveryEnv(this.env)
              .then(res => {
                this.Loading = false;
                this.$message.success('更新成功')
                this.onSuccess && this.onSuccess()
              })
              .catch(err => {
                this.Loading = false;
                errorHandle(err)
              });
          } else {
            createDeliveryEnv(this.env)
              .then(res => {
                this.Loading = false;
                this.$message.success('添加成功')
                this.onSuccess && this.onSuccess()
              })
              .catch(err => {
                this.Loading = false;
                errorHandle(err)
              });
          }

        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.envform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/deliverManage/environment/components/editEnv.vue